<data-table label="Delivery receipts" [seamless]="true" [loading]="loading" [maxHeight]="'640px'" [skeletonColumns]="5" [resizable]="false">
  @if (rows.length > 0 || loading) {
    <table class="bk-log">
      <thead>
        <tr>
          <th scope="col" class="col-who">Recipient</th>
          <th scope="col" class="col-group">Group</th>
          <th scope="col" class="col-gender">Gender</th>
          <th scope="col" class="num col-age">Age</th>
          <th scope="col" class="col-country">Country</th>
          <th scope="col" class="col-status">Delivery</th>
          <th scope="col" class="col-when">Receipt</th>
        </tr>
      </thead>
      <tbody>
        @for (row of rows; track row.key) {
          <tr [class.is-failed]="row.failed">
            <td class="col-who">
              <span class="bk-msg">
                <span class="bk-msg__subject">{{ row.name || row.number || "Unknown recipient" }}</span>
                @if (row.name && row.number) {
                  <span class="bk-msg__preview">{{ row.number }}</span>
                }
              </span>
            </td>
            <td class="quiet col-group">{{ row.group || "—" }}</td>
            <td class="quiet col-gender">{{ row.gender || "—" }}</td>
            <td class="num quiet col-age">{{ row.age || "—" }}</td>
            <td class="quiet col-country">{{ row.country || "—" }}</td>
            <td class="col-status">
              <span class="status-cell">
                <app-status [text]="row.statusLabel" [status]="row.statusTone" />
                @if (row.blacklisted) {
                  <span class="flag">Blacklisted</span>
                }
              </span>
            </td>
            <td class="quiet col-when">
              <time [attr.datetime]="row.iso || null" [attr.title]="row.exact || null">{{ row.when }}</time>
            </td>
          </tr>
        }
      </tbody>
    </table>
  } @else {
    <app-empty-state
      icon="reports"
      [message]="emptyMessage"
      [hint]="emptyHint"
      [filteredHint]="filteredHint"
      [query]="query"
      [filtered]="filtered"
      size="medium"
      (clear)="clear.emit()"
    />
  }
</data-table>
